exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".noMarginRadio__2YTF-, .noMarginRadio__2YTF- svg {\n  margin: 0 !important;\n}\n", ""]);

// Exports
exports.locals = {
	"noMarginRadio": "noMarginRadio__2YTF-"
};